// deprecate
module.exports = `
mutation ($items: [InputFeedItem]){
	blockFeedItem(items: $items)
}`;
